import { z } from "zod";

export const SortDir = z.enum(["asc", "desc"]);
export type SortDir = z.infer<typeof SortDir>;

export const ListQueryParams = z.object({
  q: z.string().optional(),
  sort: z.string().optional(),
  dir: SortDir.optional(),
});
export type ListQueryParams = z.infer<typeof ListQueryParams>;
